module.exports = __webpack_public_path__ + "img/place_logo_footprint.aa96139f.png";